module.exports = __webpack_public_path__ + "static/media/drn-logo.42e5d162.png";